/*open-close desktop catalog menu*/
(function () {
    $(document).ready(function () {
        const catalogMenuDesktop = $('#catalog-menu-desktop');

        $('.a-header__catalogBtn').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            if (catalogMenuDesktop.hasClass('active')) {
                catalogMenuDesktop.removeClass('active');
                $this.find('.a-header__icon.a-header__icon_catalog').removeClass('menu-desktop-open');
                $this.removeClass('menu-mobile-open');
                $('body').removeClass('catalog-menu-desktop-open');
                $('body').removeClass('overflowY_hidden');
            } else {
                $('body').addClass('overflowY_hidden');
                $('body').addClass('catalog-menu-desktop-open');
                $this.addClass('menu-desktop-open');
                $this.find('.a-header__icon.a-header__icon_catalog').addClass('menu-desktop-open');
                catalogMenuDesktop.addClass('active');
            }

        });
    });
})();

/*open-close mobile catalog menu*/
(function () {
    $(document).ready(function () {
        const catalogMenuMobile = $('#catalog-menu-mobile');
        const body = $('body');
        const burgerMenuMobile = $('#h-menu-mobile'); //burger-menu
        const btnHamburger = $('#h-hamburger');
        const sCatalogMenuMobile_btnHeader = $('#s-menu-catalog-mobile-btn-header');

        function open_catalogMenuMobile(btn) {

            //if burger-menu mobile was opened
            if (body.hasClass('menu-mobile-open')) {
                //close burger-menu
                burgerMenuMobile.removeClass('active');
                btnHamburger.removeClass('menu-mobile-open');
                body.removeClass('menu-mobile-open');
                body.removeClass('overflowY_hidden');

                /*open mobile catalog menu*/
                body.addClass('s-menu-catalog-mobile-open');
                body.addClass('overflowY_hidden');
                btnHamburger.addClass('s-menu-catalog-mobile-open');
                btn.addClass('s-menu-catalog-mobile-open');
                catalogMenuMobile.addClass('active');

            } else {
                // if catalog-menu mobile was opened
                if (catalogMenuMobile.hasClass('active')) {
                    /*close mobile catalog menu*/
                    catalogMenuMobile.removeClass('active');
                    btn.removeClass('s-menu-catalog-mobile-open');
                    sCatalogMenuMobile_btnHeader.removeClass('s-menu-catalog-mobile-open');
                    btnHamburger.removeClass('s-menu-catalog-mobile-open');
                    body.removeClass('s-menu-catalog-mobile-open');
                    body.removeClass('overflowY_hidden');

                } else {
                    /*open mobile catalog menu*/
                    body.addClass('s-menu-catalog-mobile-open');
                    body.addClass('overflowY_hidden');
                    btnHamburger.addClass('s-menu-catalog-mobile-open');
                    btn.addClass('s-menu-catalog-mobile-open');
                    catalogMenuMobile.addClass('active');
                }
            }
        }

        $('#s-menu-catalog-mobile-btn-header').on('click', function (e) {
            e.preventDefault();

            console.log('click burger-menu catalog btn');

            var $this = $(this);

            open_catalogMenuMobile($this);
        });

        $('#s-menu-catalog-mobile-btn-bottom').on('click', function (e) {
            e.preventDefault();

            console.log('click bottom catalog btn');

            var $this = $(this);

            open_catalogMenuMobile($this);
        });

        // btnHamburger.on('click', function (e) {
        //     e.preventDefault();
        //
        //     var $this = $(this);
        //
        //     if($this.hasClass('s-menu-catalog-mobile-open')) {
        //         /*close mobile catalog menu*/
        //         catalogMenuMobile.removeClass('active');
        //         $this.removeClass('s-menu-catalog-mobile-open');
        //         // btn.removeClass('s-menu-catalog-mobile-open');
        //         btnHamburger.removeClass('s-menu-catalog-mobile-open');
        //         body.removeClass('s-menu-catalog-mobile-open');
        //         body.removeClass('overflowY_hidden');
        //     }
        // });
    });
})();

/*changing catalog-menu nav content*/
(function () {
    $(document).ready(function () {
        var navItems = document.querySelectorAll(".catalogMenu .categories__item");

        function currentNavActive(navs) {
            navs.forEach(function (elem) {
                elem.classList.remove('active');
            })
        };

        navItems.forEach(function (item) {

            if ($(window).width() < 768) {
                /*mobile nav content changing - on click*/

                //отмена перехода по ссылке
                var navItemLink_mobile = item.querySelector('a.categories__link_mobile');
                navItemLink_mobile.addEventListener("click", function (e) {
                    e.preventDefault();
                });

                //смена контента меню ко клику
                item.addEventListener("click", function (event) {
                    document.querySelectorAll(".catalogMenu .catalogMenu__contentWrap").forEach(function (content) {
                        content.style.display = "none";
                        item.classList.remove('active');
                    });

                    var contentWrap = document.querySelectorAll(".catalogMenu #" + this.getAttribute("data-contentClass"));

                    contentWrap && contentWrap.forEach(function (content) {
                        content.style.display = "flex";
                        currentNavActive(navItems);
                        item.classList.add('active');
                    });
                });
            } else {
                /*desktop nav content changing - on hover*/
                //смена контента меню при рнаведении
                item.addEventListener("mouseover", function (event) {
                    document.querySelectorAll(".catalogMenu .catalogMenu__contentWrap").forEach(function (content) {
                        content.style.display = "none";
                        item.classList.remove('active');
                    });

                    var contentWrap = document.querySelectorAll(".catalogMenu #" + this.getAttribute("data-contentClass"));

                    contentWrap && contentWrap.forEach(function (content) {
                        content.style.display = "flex";
                        currentNavActive(navItems);
                        item.classList.add('active');
                    });
                });
            }
        });
    });
})();
